import type { Chapter } from '@/types'

const CONTENT_FIELDS = ['jsonContent', 'title', 'content'] as const

/**
 * Applies non-content fields from a server chapter onto the local editor state.
 * PATCH responses must not replace jsonContent/title while the user may still be typing.
 */
export function mergeChapterServerMetadata(local: Chapter, server: Chapter): Chapter {
  const merged: Chapter = { ...local }
  for (const [key, value] of Object.entries(server) as [keyof Chapter, Chapter[keyof Chapter]][]) {
    if (CONTENT_FIELDS.includes(key as (typeof CONTENT_FIELDS)[number])) {
      continue
    }
    if (value !== undefined) {
      ;(merged as unknown as Record<string, unknown>)[key] = value
    }
  }
  return merged
}
